module.exports = __webpack_public_path__ + "img/night-flow-en.1945469d.png";